import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { actionConfigs: Object }
  static targets = ["actionSelect", "notesField", "notesInput", "subjectField", "subjectSelect"]

  connect() {
    this.updateFieldVisibility()
  }

  actionChanged() {
    this.updateFieldVisibility()
  }

  updateFieldVisibility() {
    const selectedUlid = this.actionSelectTarget.value
    const config = this.actionConfigsValue[selectedUlid]

    if (!config) {
      this.hideField(this.notesFieldTarget)
      this.hideField(this.subjectFieldTarget)
      return
    }

    // Notes field
    if (config.notesRequirement === "none") {
      this.hideField(this.notesFieldTarget)
      if (this.hasNotesInputTarget) {
        this.notesInputTarget.removeAttribute("required")
      }
    } else {
      this.showField(this.notesFieldTarget)
      if (this.hasNotesInputTarget) {
        if (config.notesRequirement === "required") {
          this.notesInputTarget.setAttribute("required", "required")
        } else {
          this.notesInputTarget.removeAttribute("required")
        }
      }
    }

    // Subject field
    if (config.subjectType) {
      this.showField(this.subjectFieldTarget)
    } else {
      this.hideField(this.subjectFieldTarget)
    }
  }

  hideField(element) {
    element.classList.add("hidden")
  }

  showField(element) {
    element.classList.remove("hidden")
  }
}
